import { useQuery } from '@tanstack/react-query';
import { getCounterPartiesList } from '@/fsd/entities/counter-party';
import { Option } from '@/fsd/shared/ui/CustomSelect/CustomSelect';

export const useCounterpartiesSelectOptions = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['counterparties'],
    queryFn: () => getCounterPartiesList({}),
  });

  const options: Option[] =
    data?.data.map((cp) => ({
      name: String(cp.name),
      value: String(cp.id),
      id: cp.id,
    })) || [];

  return { options, isLoading, isError };
};
